/* eslint-disable no-useless-escape */
export const exceptionsMessages = {
  ADMIN_STUDENT_USERNAME: 'Escribe el nombre de usuario',
  USERNAME_EXISTS: 'Ya existe un usuario con este nombre de usuario',
  USERNAME_WRONG: 'El nombre de usuario no es correcto',
}

const getUsernameException = ({ code }) => {
  switch (code) {
  case 'IllegalFormatUsernameException': return 'USERNAME_WRONG'
  case 'UsernameRequiredException': return 'ADMIN_STUDENT_USERNAME'
  case 'UsernameAlreadyExistsException': return 'USERNAME_EXISTS'
  default: return null
  }
}

const exceptionUsernameParser = ({ code }) => (
  exceptionsMessages[getUsernameException({ code })]
)

export default exceptionUsernameParser
